export default {
    state: {
        pointsNum: 0,
    }
}
